import axios from "axios";
import Vue from "vue";

var instance = axios.create({
    baseURL: window.location.origin,
});

export default {
    namespaced: true,
    state: {
        deliveryMonitoringReports: [],
        billCollectorReports: [],
        PDCCollectionReports: [],
        binCardReports: [],
        salesReports: [],
        stockOnHandReports: [],
        inventoryLevelLast: {},
        inventoryLevelReports: [],
        consignmentOrderLast: {},
        consignmentOrderReports: [],
        pendingSalesOrderLast: {},
        pendingSalesOrderReports: [],
        pendingSalesOrderCSLast: {},
        pendingSalesOrderCSReports: [],
        detailedAgingByPrincipalInitialStockingLast: {},
        detailedAgingByPrincipalGuaranteedAccountLast: {},
        detailedAgingByPrincipalReports: [],
        deliveryMonitoringReportFilter: {
            principalCode: '',
            isOfficial: false,
            dateRange: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
        },
        billCollectorReportFilter: {
            principalCode: '',
            isOfficial: false,
            date: new Date(),
        },
        PDCCollectionReportFilter: {
            principalCode: '',
            isOfficial: false,
            dateRange: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
        },
        stockOnHandReportFilter: {
            principalCode: '',
            isOfficial: false,
            date: new Date(),
            // dateRange: [new Date(), new Date()],
        },
        invoiceListingReportFilter: {
            principalCode: '',
            isOfficial: false,
            dateRange: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
            timePicked: ''
        },
        salesSummaryReportFilter: {
            principalCode: '',
            isOfficial: false,
            dateRange: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
            timePicked: ''
        },
        salesReturnReportFilter: {
            principalCode: '',
            isOfficial: false,
            dateRange: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
            timePicked: ''
        },
        inventoryLevelReportFilter: {
            principalCode: '',
            isOfficial: false,
            date: new Date(),
        },
        consignmentOrderReportFilter: {
            // principalCode: '',
            targetCode: '', //Used for principal code and agent code
            isOfficial: false,
            date: new Date(),
        },
        pendingSalesOrderReportFilter: {
            principalCode: '',
            isOfficial: false,
            date: new Date(),
            dateRange: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
            timePicked: ''
        },
        pendingSalesOrderCSReportFilter: {
            principalCode: '',
            isOfficial: false,
            date: new Date(),
            timePicked: ''
        },
        detailedAgingByPrincipalReportFilter: {
            principalCode: '',
            isOfficial: false,
            date: new Date(),
            dateRange: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
        }
    },
    getters: {
        salesSummaryReportFilter(state) {
            let yearFrom = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.salesSummaryReportFilter.dateRange[0]);
            let monthFrom = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.salesSummaryReportFilter.dateRange[0]);
            let dayFrom = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.salesSummaryReportFilter.dateRange[0]);
            var dateFrom = `${yearFrom}-${monthFrom}-${dayFrom}`;

            let yearTo = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.salesSummaryReportFilter.dateRange[1]);
            let monthTo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.salesSummaryReportFilter.dateRange[1]);
            let dayTo = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.salesSummaryReportFilter.dateRange[1]);
            var dateTo = `${yearTo}-${monthTo}-${dayTo}`;

            return {
                principalCode: state.salesSummaryReportFilter.principalCode,
                isOfficial: state.salesSummaryReportFilter.isOfficial,
                dateFrom: dateFrom,
                dateTo: dateTo,
                timePicked: state.salesSummaryReportFilter.timePicked
            }
        },
        salesReturnReportFilter(state) {
            let yearFrom = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.salesReturnReportFilter.dateRange[0]);
            let monthFrom = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.salesReturnReportFilter.dateRange[0]);
            let dayFrom = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.salesReturnReportFilter.dateRange[0]);
            var dateFrom = `${yearFrom}-${monthFrom}-${dayFrom}`;

            let yearTo = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.salesReturnReportFilter.dateRange[1]);
            let monthTo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.salesReturnReportFilter.dateRange[1]);
            let dayTo = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.salesReturnReportFilter.dateRange[1]);
            var dateTo = `${yearTo}-${monthTo}-${dayTo}`;

            return {
                principalCode: state.salesReturnReportFilter.principalCode,
                isOfficial: state.salesReturnReportFilter.isOfficial,
                dateFrom: dateFrom,
                dateTo: dateTo,
                timePicked: state.salesReturnReportFilter.timePicked
            }
        },
        deliveryMonitoringReportFilter(state) {
            let yearFrom = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.deliveryMonitoringReportFilter.dateRange[0]);
            let monthFrom = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.deliveryMonitoringReportFilter.dateRange[0]);
            let dayFrom = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.deliveryMonitoringReportFilter.dateRange[0]);
            var dateFrom = `${yearFrom}-${monthFrom}-${dayFrom}`;

            let yearTo = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.deliveryMonitoringReportFilter.dateRange[1]);
            let monthTo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.deliveryMonitoringReportFilter.dateRange[1]);
            let dayTo = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.deliveryMonitoringReportFilter.dateRange[1]);
            var dateTo = `${yearTo}-${monthTo}-${dayTo}`;

            return {
                principalCode: state.deliveryMonitoringReportFilter.principalCode,
                isOfficial: state.deliveryMonitoringReportFilter.isOfficial,
                dateFrom: dateFrom,
                dateTo: dateTo
            }
        },
        billCollectorReportFilter(state) {
            let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.billCollectorReportFilter.date);
            let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.billCollectorReportFilter.date);
            let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.billCollectorReportFilter.date);
            var date = `${year}-${month}-${day}`;
            return {
                principalCode: state.billCollectorReportFilter.principalCode,
                isOfficial: state.billCollectorReportFilter.isOfficial,
                date: date
            }
        },
        PDCCollectionReportFilter(state) {
            let yearFrom = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.PDCCollectionReportFilter.dateRange[0]);
            let monthFrom = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.PDCCollectionReportFilter.dateRange[0]);
            let dayFrom = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.PDCCollectionReportFilter.dateRange[0]);
            var dateFrom = `${yearFrom}-${monthFrom}-${dayFrom}`;

            let yearTo = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.PDCCollectionReportFilter.dateRange[1]);
            let monthTo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.PDCCollectionReportFilter.dateRange[1]);
            let dayTo = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.PDCCollectionReportFilter.dateRange[1]);
            var dateTo = `${yearTo}-${monthTo}-${dayTo}`;

            return {
                principalCode: state.PDCCollectionReportFilter.principalCode,
                isOfficial: state.PDCCollectionReportFilter.isOfficial,
                dateFrom: dateFrom,
                dateTo: dateTo
            }
        },
        stockOnHandReportFilter(state) {
            // let yearFrom = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.stockOnHandReportFilter.dateRange[0]);
            // let monthFrom = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.stockOnHandReportFilter.dateRange[0]);
            // let dayFrom = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.stockOnHandReportFilter.dateRange[0]);
            // var dateFrom = `${yearFrom}-${monthFrom}-${dayFrom}`;

            // let yearTo = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.stockOnHandReportFilter.dateRange[1]);
            // let monthTo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.stockOnHandReportFilter.dateRange[1]);
            // let dayTo = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.stockOnHandReportFilter.dateRange[1]);
            // var dateTo = `${yearTo}-${monthTo}-${dayTo}`;

            let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.stockOnHandReportFilter.date);
            let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.stockOnHandReportFilter.date);
            let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.stockOnHandReportFilter.date);
            var date = `${year}-${month}-${day}`;
            return {
                principalCode: state.stockOnHandReportFilter.principalCode,
                isOfficial: state.stockOnHandReportFilter.isOfficial,
                //dateFrom: dateFrom,
                dateTo: date
            }
        },
        inventoryLevelReportFilter(state) {
            let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.inventoryLevelReportFilter.date);
            let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.inventoryLevelReportFilter.date);
            let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.inventoryLevelReportFilter.date);
            var date = `${year}-${month}-${day}`;
            return {
                principalCode: state.inventoryLevelReportFilter.principalCode,
                isOfficial: state.inventoryLevelReportFilter.isOfficial,
                //dateFrom: dateFrom,
                //dateTo: dateTo,
                date: date
            }
        },
        consignmentOrderReportFilter(state) {
            let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.consignmentOrderReportFilter.date);
            let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.consignmentOrderReportFilter.date);
            let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.consignmentOrderReportFilter.date);
            var date = `${year}-${month}-${day}`;
            return {
                targetCode: state.consignmentOrderReportFilter.targetCode,
                isOfficial: state.consignmentOrderReportFilter.isOfficial,
                //dateFrom: dateFrom,
                //dateTo: dateTo,
                date: date
            }
        },
        pendingSalesOrderReportFilter(state) {
            let yearFrom = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.pendingSalesOrderReportFilter.dateRange[0]);
            let monthFrom = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.pendingSalesOrderReportFilter.dateRange[0]);
            let dayFrom = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.pendingSalesOrderReportFilter.dateRange[0]);
            var dateFrom = `${yearFrom}-${monthFrom}-${dayFrom}`;

            let yearTo = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.pendingSalesOrderReportFilter.dateRange[1]);
            let monthTo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.pendingSalesOrderReportFilter.dateRange[1]);
            let dayTo = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.pendingSalesOrderReportFilter.dateRange[1]);
            var dateTo = `${yearTo}-${monthTo}-${dayTo}`;

            let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.pendingSalesOrderReportFilter.date);
            let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.pendingSalesOrderReportFilter.date);
            let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.pendingSalesOrderReportFilter.date);
            var date = `${year}-${month}-${day}`;

            return {
                principalCode: state.pendingSalesOrderReportFilter.principalCode,
                isOfficial: state.pendingSalesOrderReportFilter.isOfficial,
                dateFrom: dateFrom,
                dateTo: dateTo,
                date: date,
                timePicked: state.pendingSalesOrderReportFilter.timePicked,
            }
        },
        pendingSalesOrderCSReportFilter(state) {

            let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.pendingSalesOrderCSReportFilter.date);
            let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.pendingSalesOrderCSReportFilter.date);
            let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.pendingSalesOrderCSReportFilter.date);
            var date = `${year}-${month}-${day}`;

            return {
                principalCode: state.pendingSalesOrderCSReportFilter.principalCode,
                isOfficial: state.pendingSalesOrderCSReportFilter.isOfficial,
                // dateFrom: dateFrom,
                // dateTo: dateTo
                date: date,
                timePicked: state.pendingSalesOrderCSReportFilter.timePicked
            }
        },
        detailedAgingByPrincipalReportFilter(state) {
            let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.detailedAgingByPrincipalReportFilter.date);
            let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.detailedAgingByPrincipalReportFilter.date);
            let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.detailedAgingByPrincipalReportFilter.date);
            var date = `${year}-${month}-${day}`;

            let yearFrom = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.detailedAgingByPrincipalReportFilter.dateRange[0]);
            let monthFrom = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.detailedAgingByPrincipalReportFilter.dateRange[0]);
            let dayFrom = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.detailedAgingByPrincipalReportFilter.dateRange[0]);
            var dateFrom = `${yearFrom}-${monthFrom}-${dayFrom}`;

            let yearTo = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.detailedAgingByPrincipalReportFilter.dateRange[1]);
            let monthTo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.detailedAgingByPrincipalReportFilter.dateRange[1]);
            let dayTo = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.detailedAgingByPrincipalReportFilter.dateRange[1]);
            var dateTo = `${yearTo}-${monthTo}-${dayTo}`;

            return {
                principalCode: state.detailedAgingByPrincipalReportFilter.principalCode,
                isOfficial: state.detailedAgingByPrincipalReportFilter.isOfficial,
                date: date,
                dateRangeFrom: dateFrom,
                dateRangeTo: dateTo,
                timePicked: state.pendingSalesOrderCSReportFilter.timePicked
            }
        },
        invoiceListingReportFilter(state) {
            let yearFrom = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.invoiceListingReportFilter.dateRange[0]);
            let monthFrom = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.invoiceListingReportFilter.dateRange[0]);
            let dayFrom = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.invoiceListingReportFilter.dateRange[0]);
            var dateFrom = `${yearFrom}-${monthFrom}-${dayFrom}`;

            let yearTo = new Intl.DateTimeFormat("en", { year: "numeric" }).format(state.invoiceListingReportFilter.dateRange[1]);
            let monthTo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(state.invoiceListingReportFilter.dateRange[1]);
            let dayTo = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(state.invoiceListingReportFilter.dateRange[1]);
            var dateTo = `${yearTo}-${monthTo}-${dayTo}`;

            return {
                principalCode: state.invoiceListingReportFilter.principalCode,
                isOfficial: state.invoiceListingReportFilter.isOfficial,
                dateFrom: dateFrom,
                dateTo: dateTo,
                timePicked: state.invoiceListingReportFilter.timePicked
            }
        },
    },
    mutations: {
        SET_DeliveryMonitoring(state, data) {
            state.deliveryMonitoringReports = data;
        },
        SET_BillCollector(state, data) {
            state.billCollectorReports = data;
        },
        SET_PDCCollection(state, data) {
            state.PDCCollectionReports = data;
        },
        SET_BinCard(state, data) {
            state.binCardReports = data;
        },
        SET_SalesReport(state, data) {
            state.salesReports = data;
        },
        SET_StockOnHand(state, data) {
            state.stockOnHandReports = data;
        },
        SET_DetailedAgingByPrincipal_InitialStocking(state, data) {
            state.detailedAgingByPrincipalInitialStockingLast = data;
        },
        SET_DetailedAgingByPrincipal_GuaranteedAccount(state, data) {
            state.detailedAgingByPrincipalGuaranteedAccountLast = data;
        },
        SET_DetailedAgingByPrincipalFilter_Date(state, data) {
            if (data != null) {
                let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(new Date(data.dateAsOf));
                let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(new Date(data.dateAsOf));
                let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(new Date(data.dateAsOf));
                var date = `${year}-${month}-${day}`;
                
                state.detailedAgingByPrincipalReportFilter.date = date;
            }
        },
        SET_InventoryLevelLast(state, data) {
            state.inventoryLevelLast = data;
        },
        SET_ConsignmentOrderLast(state, data) {
            state.consignmentOrderLast = data;
        },
        SET_PendingSalesOrderLast(state, data) {
            state.pendingSalesOrderLast = data;
        },
        SET_PendingSalesOrderCSLast(state, data) {
            state.pendingSalesOrderCSLast = data;
        }
    },
    actions: {
        GetBillCollectorReports({ getters, rootGetters }) {
            var filter = getters.billCollectorReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/billCollector?isofficial=" + filter.isOfficial + "&principalCode=" + filter.principalCode + "&date=" + filter.date, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetBillCollectorReportsAgent({ getters, rootGetters }) {
            var filter = getters.billCollectorReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/billCollector/agent?isofficial=" + filter.isOfficial + "&agentCode=" + filter.principalCode + "&date=" + filter.date, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetBillCollectorReportsDM({ getters, rootGetters }) {
            var filter = getters.billCollectorReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/billCollector/dm?isofficial=" + filter.isOfficial + "&dmCode=" + filter.principalCode + "&date=" + filter.date, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetBillCollectorReportsNSM({ getters, rootGetters }) {
            var filter = getters.billCollectorReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/billCollector/nsm?isofficial=" + filter.isOfficial + "&nsmCode=" + filter.principalCode + "&date=" + filter.date, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetBillCollectorReportsRSM({ getters, rootGetters }) {
            var filter = getters.billCollectorReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/billCollector/rsm?isofficial=" + filter.isOfficial + "&rsmCode=" + filter.principalCode + "&date=" + filter.date, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetBillCollectorReportsRSM_V2({ getters, rootGetters }) {
            var filter = getters.billCollectorReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/billCollector/rsm/v2?isofficial=" + filter.isOfficial + "&rsmCode=" + filter.principalCode + "&date=" + filter.date, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        UploadBillCollector({ rootGetters }, payload) {
            let formData = new FormData();
            formData.append('file', payload);

            return new Promise((resolve, reject) => {
                instance
                    .post("api/Upload/billCollector", formData, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetBillCollectorValidation({ getters, rootGetters }) {
            var filter = getters.billCollectorReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/billCollector/validation?principalCode=" + filter.principalCode + "&date=" + filter.date, {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();

                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetPDCCollectionReports({ getters, rootGetters }) {
            var filter = getters.PDCCollectionReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/PDCCollection?isofficial=" + filter.isOfficial + "&agentCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetPDCCollectionDMReports({ getters, rootGetters }) {
            var filter = getters.PDCCollectionReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/PDCCollection/dm?isofficial=" + filter.isOfficial + "&dmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetPDCCollectionNSMReports({ getters, rootGetters }) {
            var filter = getters.PDCCollectionReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/PDCCollection/nsm?isofficial=" + filter.isOfficial + "&nsmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetPDCCollectionRSMReports({ getters, rootGetters }) {
            var filter = getters.PDCCollectionReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/PDCCollection/rsm?isofficial=" + filter.isOfficial + "&rsmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetPDCCollectionRSMReports_V2({ getters, rootGetters }) {
            var filter = getters.PDCCollectionReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/PDCCollection/rsm/v2?isofficial=" + filter.isOfficial + "&rsmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        UploadPDCCollection({ rootGetters }, payload) {
            let formData = new FormData();
            formData.append('file', payload);

            return new Promise((resolve, reject) => {
                instance
                    .post("api/Upload/PDCCollection", formData, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetPDCCollectionValidation({ getters, rootGetters }) {
            var filter = getters.PDCCollectionReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/PDCCollection/validation?agentCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();

                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetPDCCollectionValidationV2({ getters, rootGetters }) {
            var filter = getters.PDCCollectionReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/PDCCollection/validation/v2", {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();

                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetDeliveryMonitoringReports({ getters, rootGetters }) {
            var filter = getters.deliveryMonitoringReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/deliverymonitoring?isofficial=" + filter.isOfficial + "&principalcode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetAgentDeliveryMonitoringReports({ getters, rootGetters }) {
            var filter = getters.deliveryMonitoringReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/deliverymonitoring/agent?isofficial=" + filter.isOfficial + "&agentcode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetDMDeliveryMonitoringReports({ getters, rootGetters }) {
            var filter = getters.deliveryMonitoringReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/deliverymonitoring/dm?isofficial=" + filter.isOfficial + "&dmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetNSMDeliveryMonitoringReports({ getters, rootGetters }) {
            var filter = getters.deliveryMonitoringReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/deliverymonitoring/nsm?isofficial=" + filter.isOfficial + "&nsmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetRSMDeliveryMonitoringReports({ getters, rootGetters }) {
            var filter = getters.deliveryMonitoringReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/deliverymonitoring/rsm?isofficial=" + filter.isOfficial + "&rsmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetRSMDeliveryMonitoringReports_V2({ getters, rootGetters }) {
            var filter = getters.deliveryMonitoringReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/deliverymonitoring/rsm/v2?isofficial=" + filter.isOfficial + "&rsmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        UploadDeliveryMonitoring({ rootGetters }, payload) {
            let formData = new FormData();
            formData.append('file', payload);

            return new Promise((resolve, reject) => {
                instance
                    .post("api/Upload/deliverymonitoring", formData, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetDeliveryMonitoringValidation({ getters, rootGetters }) {
            var filter = getters.deliveryMonitoringReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/deliverymonitoring/validation?principalcode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();

                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetBinCardReports({ commit, rootGetters }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/bincards", {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        //commit('SET_BinCard', response.data)
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        UploadBinCard({ rootGetters }, payload) {
            let formData = new FormData();
            formData.append('file', payload);

            return new Promise((resolve, reject) => {
                instance
                    .post("api/Upload/bincards", formData, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetSalesReports({ commit, rootGetters }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/summary", {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        //commit('SET_SalesReport', response.data)
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        UploadSalesReport({ rootGetters }, payload) {
            let formData = new FormData();
            formData.append('file', payload);

            return new Promise((resolve, reject) => {
                instance
                    .post("api/Upload/v1/salestransaction", formData, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        UploadSalesReportV2({ rootGetters }, payload) {
            let formData = new FormData();
            formData.append('file', payload);

            return new Promise((resolve, reject) => {
                instance
                    .post("api/Upload/v2/salestransaction", formData, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetStockOnHandReports({ getters, rootGetters }) {
            var filter = getters.stockOnHandReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/stockonhand?isofficial=" + filter.isOfficial + "&principalcode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        //commit('SET_StockOnHand', response.data)
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetStockOnHandFieldforceReports({ getters, rootGetters }) {
            var filter = getters.stockOnHandReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/stockonhand/fieldforce?isofficial=" + filter.isOfficial + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        //commit('SET_StockOnHand', response.data)
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetStockOnHandDMReports({ getters, rootGetters }) {
            var filter = getters.stockOnHandReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/stockonhand/dm?isofficial=" + filter.isOfficial + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        //commit('SET_StockOnHand', response.data)
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetStockOnHandNSMReports({ getters, rootGetters }) {
            var filter = getters.stockOnHandReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/stockonhand/nsm?isofficial=" + filter.isOfficial + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        //commit('SET_StockOnHand', response.data)
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetStockOnHandRSMReports({ getters, rootGetters }) {
            var filter = getters.stockOnHandReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/stockonhand/rsm?isofficial=" + filter.isOfficial + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        //commit('SET_StockOnHand', response.data)
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetStockOnHandRSMReports_V2({ getters, rootGetters }) {
            var filter = getters.stockOnHandReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/Report/stockonhand/rsm/v2?isofficial=" + filter.isOfficial + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        //commit('SET_StockOnHand', response.data)
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        UploadStockOnHandV2({ rootGetters }, payload) {
            let formData = new FormData();
            formData.append('file', payload);

            return new Promise((resolve, reject) => {
                instance
                    .post("api/Upload/stockonhand", formData, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetStockOnHandValidation({ getters, rootGetters }) {
            var filter = getters.stockOnHandReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/stockonhand/validation?principalcode=" + filter.principalCode + "&date=" + filter.dateTo, {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();

                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        SyncStockOnHand({ commit, rootGetters }) {
            return new Promise((resolve, reject) => {
                instance
                    .post("api/Integration/pending-sales-order/transfer", {}, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(async function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        reject(error.response);
                    });
            });
        },
        GenerateInvoiceListing({ getters, rootGetters }) {
            var filter = getters.invoiceListingReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/invoicelisting?isofficial=" + filter.isOfficial + "&principalcode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo + "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateAgentInvoiceListing({ getters, rootGetters }) {
            var filter = getters.invoiceListingReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/invoicelisting/agent?isofficial=" + filter.isOfficial + "&agentCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo + "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateDMInvoiceListing({ getters, rootGetters }) {
            var filter = getters.invoiceListingReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/invoicelisting/dm?isofficial=" + filter.isOfficial + "&dmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo + "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateNSMInvoiceListing({ getters, rootGetters }) {
            var filter = getters.invoiceListingReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/invoicelisting/nsm?isofficial=" + filter.isOfficial + "&nsmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo + "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateRSMInvoiceListing({ getters, rootGetters }) {
            var filter = getters.invoiceListingReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/invoicelisting/rsm?isofficial=" + filter.isOfficial + "&rsmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo + "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateRSMInvoiceListing_V2({ getters, rootGetters }) {
            var filter = getters.invoiceListingReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/invoicelisting/rsm/v2?isofficial=" + filter.isOfficial + "&rsmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateSalesSummary({ getters, rootGetters }) {
            var filter = getters.salesSummaryReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/salessummary?isofficial=" + filter.isOfficial + "&principalcode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo + "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateAgentSalesSummary({ getters, rootGetters }) {
            var filter = getters.salesSummaryReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/salessummary/agent?isofficial=" + filter.isOfficial + "&agentCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo + "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateDMSalesSummary({ getters, rootGetters }) {
            var filter = getters.salesSummaryReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/salessummary/dm?isofficial=" + filter.isOfficial + "&dmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo + "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateNSMSalesSummary({ getters, rootGetters }) {
            var filter = getters.salesSummaryReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/salessummary/nsm?isofficial=" + filter.isOfficial + "&nsmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo + "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateRSMSalesSummary({ getters, rootGetters }) {
            var filter = getters.salesSummaryReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/salessummary/rsm?isofficial=" + filter.isOfficial + "&rsmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo + "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateRSMSalesSummary_V2({ getters, rootGetters }) {
            var filter = getters.salesSummaryReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/salessummary/rsm/v2?isofficial=" + filter.isOfficial + "&rsmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateSalesReturn({ getters, rootGetters }) {
            var filter = getters.salesReturnReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/returns?isofficial=" + filter.isOfficial + "&principalcode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo + "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateAgentSalesReturn({ getters, rootGetters }) {
            var filter = getters.salesReturnReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/returns/agent?isofficial=" + filter.isOfficial + "&agentCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo + "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateDMSalesReturn({ getters, rootGetters }) {
            var filter = getters.salesReturnReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/returns/dm?isofficial=" + filter.isOfficial + "&dmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo + "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateNSMSalesReturn({ getters, rootGetters }) {
            var filter = getters.salesReturnReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/returns/nsm?isofficial=" + filter.isOfficial + "&nsmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo + "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateRSMSalesReturn({ getters, rootGetters }) {
            var filter = getters.salesReturnReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/returns/rsm?isofficial=" + filter.isOfficial + "&rsmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo + "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateRSMSalesReturn_V2({ getters, rootGetters }) {
            var filter = getters.salesReturnReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/returns/rsm/v2?isofficial=" + filter.isOfficial + "&rsmCode=" + filter.principalCode + "&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetInventoryLevelReports({ getters, rootGetters }) {
            var filter = getters.inventoryLevelReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/inventorylevel?isofficial=" + filter.isOfficial + "&principalcode=" + filter.principalCode + "&date=" + filter.date, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        UploadInventoryLevelReports({ rootGetters }, payload) {
            let formData = new FormData();
            formData.append('file', payload);

            return new Promise((resolve, reject) => {
                instance
                    .post("api/Upload/inventorylevel", formData, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetInventoryLevel_Date({ getters, rootGetters, commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/inventorylevel/last", {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        commit('SET_InventoryLevelLast', response.data)
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetInventoryLevelReports_Template({ getters, rootGetters, commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/inventorylevel/template", {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();

                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetInventoryLevelValidation({ getters, rootGetters }) {
            var filter = getters.inventoryLevelReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/inventorylevel/validation?&date=" + filter.date, {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();

                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetConsignmentOrderReports({ getters, rootGetters }) {
            var filter = getters.consignmentOrderReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/consignmentorder?isofficial=" + filter.isOfficial + "&principalcode=" + filter.targetCode + "&date=" + filter.date, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetConsignmentOrder_Date({ getters, rootGetters, commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/consignmentorder/last", {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        commit('SET_ConsignmentOrderLast', response.data)
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetConsignmentOrderReports_Template({ getters, rootGetters, commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/consignmentorder/template", {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();

                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetConsignmentOrderValidation({ getters, rootGetters }) {
            var filter = getters.consignmentOrderReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/consignmentorder/validation?&date=" + filter.date, {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();

                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetAgentConsignmentOrderReports({ getters, rootGetters }) {
            var filter = getters.consignmentOrderReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/consignmentorder/agent?isofficial=" + filter.isOfficial + "&agentcode=" + filter.targetCode + "&date=" + filter.date, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        UploadConsignmentOrderReports({ rootGetters }, payload) {
            let formData = new FormData();
            formData.append('file', payload);

            return new Promise((resolve, reject) => {
                instance
                    .post("api/Upload/consignmentorder", formData, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetPendingSalesOrderReports({ getters, rootGetters }) {
            var filter = getters.pendingSalesOrderReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/pendingsalesorder?isofficial=" + filter.isOfficial + 
                            "&principalcode=" + filter.principalCode + 
                            "&from=" + filter.dateFrom + 
                            "&to=" + filter.dateTo +
                            "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetPendingSalesOrder_Date({ getters, rootGetters, commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/pendingsalesorder/last", {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        commit('SET_PendingSalesOrderLast', response.data)
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetPendingSalesOrderReports_Template({ getters, rootGetters, commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/pendingsalesorder/template", {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();

                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetPendingSalesOrderReportsValidation({ getters, rootGetters }) {
            var filter = getters.pendingSalesOrderReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/pendingsalesorder/validation?&from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();

                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        UploadPendingSalesOrderReports({ rootGetters }, payload) {
            let formData = new FormData();
            formData.append('file', payload);

            return new Promise((resolve, reject) => {
                instance
                    .post("api/Upload/pendingsalesorder", formData, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetPendingSalesOrderCSReports({ getters, rootGetters }) {
            var filter = getters.pendingSalesOrderCSReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/pendingsalesordercs?isofficial=" + filter.isOfficial + 
                        "&principalcode=" + filter.principalCode + 
                        "&date=" + filter.date +
                        "&timepicked=" + filter.timePicked, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetPendingSalesOrderCS_Date({ getters, rootGetters, commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/pendingsalesordercs/last", {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    
                    .then(async function(response) {
                        commit('SET_PendingSalesOrderCSLast', response.data)
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetPendingSalesOrderCSReports_Template({ getters, rootGetters, commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/pendingsalesordercs/template", {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();

                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        UploadPendingSalesOrderCSReports({ rootGetters }, payload) {
            let formData = new FormData();
            formData.append('file', payload);

            return new Promise((resolve, reject) => {
                instance
                    .post("api/Upload/pendingsalesordercs", formData, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetDetailedAgingByPrincipalInitialStockingReports({ getters, rootGetters }) {
            var filter = getters.detailedAgingByPrincipalReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/detailedagingbyprincipal/initialstocking?isofficial=" + filter.isOfficial + "&principalcode=" + filter.principalCode + "&date=" + filter.date, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        UploadDetailedAgingByPrincipalInitialStockingReports({ rootGetters }, payload) {
            let formData = new FormData();
            formData.append('file', payload);

            return new Promise((resolve, reject) => {
                instance
                    .post("api/Upload/detailedagingbyprincipal/initialstocking", formData, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetDetailedAgingByPrincipalInitialStockingLast_Date({ getters, rootGetters, commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/detailedagingbyprincipal/initialstocking/last", {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        commit('SET_DetailedAgingByPrincipal_InitialStocking', response.data)
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
                });
            },
        GenerateDetailedAgingByPrincipalInitialStockingValidation({ getters, rootGetters }) {
            var filter = getters.detailedAgingByPrincipalReportFilter;
            
            return new Promise((resolve, reject) => {
                instance
                .get("api/report/detailedagingbyprincipal/initialstocking/validation?date=" + filter.date, {
                    responseType: 'blob',
                    headers: {
                        Authorization: "Bearer " + rootGetters.token
                    }
                })
                .then(async function(response) {
                    var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                    const url = URL.createObjectURL(new Blob([response.data], {
                        type: 'application/octet-stream'
                    }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    
                    resolve(true);
                })
                .catch(function(error) {
                    reject(error.response);
                });
            });
        },
        GetDetailedAgingByPrincipalInitialStocking_Template({ getters, rootGetters, commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/detailedagingbyprincipal/initialstocking/template", {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
        
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetDetailedAgingByPrincipalGuaranteedAccountReports({ getters, rootGetters }) {
            var filter = getters.detailedAgingByPrincipalReportFilter;

            return new Promise((resolve, reject) => {
                instance
                .get("api/report/detailedagingbyprincipal/guaranteedaccount?isofficial=" + filter.isOfficial + "&principalcode=" + filter.principalCode + "&date=" + filter.date, {
                    headers: {
                        Authorization: "Bearer " + rootGetters.token
                    }
                })
                .then(async function(response) {
                    resolve(true);
                })
                .catch(function(error) {
                    reject(error.response);
                });
            });
        },
        GetDetailedAgingByPrincipalGuaranteedAccountLast_Date({ getters, rootGetters, commit }) {
            return new Promise((resolve, reject) => {
                instance
                .get("api/report/detailedagingbyprincipal/guaranteedaccount/last", {
                    headers: {
                        Authorization: "Bearer " + rootGetters.token
                    }
                })
                .then(async function(response) {
                    commit('SET_DetailedAgingByPrincipal_GuaranteedAccount', response.data)
                    resolve(true);
                })
                .catch(function(error) {
                    reject(error.response);
                });
            });
        },
        UploadDetailedAgingByPrincipalGuaranteedAccountReports({ rootGetters }, payload) {
            let formData = new FormData();
            formData.append('file', payload);

            return new Promise((resolve, reject) => {
                instance
                    .post("api/Upload/detailedagingbyprincipal/guaranteedaccount", formData, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(async function(response) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateDetailedAgingByPrincipalGuaranteedAccountValidation({ getters, rootGetters }) {
            var filter = getters.detailedAgingByPrincipalReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/detailedagingbyprincipal/guaranteedaccount/validation?date=" + filter.date, {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();

                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetDetailedAgingByPrincipalGuaranteedAccount_Template({ getters, rootGetters, commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/detailedagingbyprincipal/guaranteedaccount/template", {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
        
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GetPendingSalesOrderCSReportsValidation({ getters, rootGetters }) {
            var filter = getters.pendingSalesOrderCSReportFilter;
        
            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/pendingsalesordercs/validation?&date=" + filter.date, {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
        
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        GenerateInvoiceLisingValidation({ getters, rootGetters }) {
            var filter = getters.invoiceListingReportFilter;

            return new Promise((resolve, reject) => {
                instance
                    .get("api/report/salestransaction/invoicelisting/validation?from=" + filter.dateFrom + "&to=" + filter.dateTo, {
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + rootGetters.token
                        }
                    })
                    .then(async function(response) {
                        var filename = response.headers['content-disposition'].split("; ")[1].split('=')[1].replace(/"/g, '');
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/octet-stream'
                        }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();

                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
    },
    modules: {},
};